import { render, staticRenderFns } from "./PageError.vue?vue&type=template&id=3f5c4e62&scoped=true&lang=pug"
import script from "./PageError.vue?vue&type=script&lang=js"
export * from "./PageError.vue?vue&type=script&lang=js"
import style0 from "./PageError.styl?vue&type=style&index=0&id=3f5c4e62&prod&lang=stylus&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f5c4e62",
  null
  
)

export default component.exports